var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAq = function SvgAq(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#7AD7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#77B347",
    fillRule: "evenodd",
    d: "M22.968 16.877a12.046 12.046 0 0 1-6.077 6.085 2.998 2.998 0 0 1-.782-.798l-.828-1.242a1.48 1.48 0 0 0-.762-.582 1.479 1.479 0 0 1-.48-2.54l.779-.648c.12-.101.253-.188.394-.258l3.155-1.577A3 3 0 0 1 19.708 15h.477a3 3 0 0 1 2.783 1.877ZM16.384.826c.16.445.166.954-.038 1.443l-.976 2.342a2 2 0 0 1-1.296 1.154l-4.097 1.17a2 2 0 0 0-1.358 2.526l.959 3.036c.532 1.685-1.222 3.181-2.802 2.391l-1.08-.54a2 2 0 0 0-1.444-.134L.549 15.272l-.09.023A12.008 12.008 0 0 1 0 12C0 5.373 5.373 0 12 0c1.547 0 3.026.293 4.384.826Z",
    clipRule: "evenodd"
  })));
};
export default SvgAq;